module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/homepage.b2bca3ca4328ed42e75f4ba765f46cd5.jpg";